import { type JiraFieldMapper, JiraFieldMappersKeys } from './MapperInterface';
import { ShortTextMapper } from './ShortTextMapper';
import { LabelsMapper } from './LabelsMapper';
import { NumberMapper } from './NumberMapper';
import { UrlMapper } from './UrlMapper';
import { DateMapper } from './DateMapper';
import { SingleOptionMapper } from './SingleOptionMapper';
import { MultiOptionsMapper } from './MultiOptionsMapper';

const JiraShortTextMapper = new ShortTextMapper();
const JiraNumberMapper = new NumberMapper();
const JiraLabelsMapper = new LabelsMapper();
const JiraUrlMapper = new UrlMapper();
const JiraDateMapper = new DateMapper();
const JiraSingleOptionMapper = new SingleOptionMapper();
const JiraMultiOptionsMapper = new MultiOptionsMapper();

export const JiraFieldMappers: Record<JiraFieldMappersKeys, JiraFieldMapper> = {
  [JiraFieldMappersKeys.ShortText]: JiraShortTextMapper,
  [JiraFieldMappersKeys.Number]: JiraNumberMapper,
  [JiraFieldMappersKeys.Labels]: JiraLabelsMapper,
  [JiraFieldMappersKeys.Url]: JiraUrlMapper,
  [JiraFieldMappersKeys.Date]: JiraDateMapper,
  [JiraFieldMappersKeys.SingleOption]: JiraSingleOptionMapper,
  [JiraFieldMappersKeys.MultiOptions]: JiraMultiOptionsMapper
};

export * from './MapperInterface';
export * from './MappingSchemaModels';
